import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FilterSection from './components/FilterSection';
import ProjectCard from './components/ProjectCard';
import ProjectDetails from './pages/ProjectDetails';
import Checkout from './pages/Checkout';
import CheckoutSuccess from './pages/CheckoutSuccess';
import CheckoutCancel from './pages/CheckoutCancel';
import CheckoutPending from './pages/CheckoutPending';
import MyAccount from './pages/MyAccount';
import CartPage from './pages/CartPage';
import CustomerAuth from './pages/CustomerAuth';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminSettings from './pages/AdminSettings';
import AdminFiles from './pages/AdminFiles';
import AdminFinanceiro from './pages/AdminFinanceiro';
import AdminEmailConfig from './pages/AdminEmailConfig';
import AdminEmailTemplates from './pages/AdminEmailTemplates';
import ResetPassword from './pages/ResetPassword';
import Footer from './components/Footer';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const HomePage = () => {
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/projects`);
      setProjects(response.data);
      setFilteredProjects(response.data);
    } catch (error) {
      console.error('Erro ao carregar projetos:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (filters) => {
    let filtered = [...projects];

    // Filter by construction type
    if (filters.constructionType) {
      filtered = filtered.filter(project => 
        project.tags.includes(filters.constructionType)
      );
    }

    // Filter by area
    if (filters.area) {
      const areaValue = parseInt(filters.area);
      filtered = filtered.filter(project => {
        const projectArea = parseInt(project.area);
        return projectArea >= areaValue - 50 && projectArea <= areaValue + 50;
      });
    }

    // Filter by bedrooms
    if (filters.bedrooms) {
      if (filters.bedrooms === '5+') {
        filtered = filtered.filter(project => project.bedrooms >= 5);
      } else {
        filtered = filtered.filter(project => 
          project.bedrooms === parseInt(filters.bedrooms)
        );
      }
    }

    // Filter by search text
    if (filters.searchText) {
      filtered = filtered.filter(project =>
        project.name.toLowerCase().includes(filters.searchText.toLowerCase()) ||
        project.description.toLowerCase().includes(filters.searchText.toLowerCase())
      );
    }

    // Filter by terrain
    if (filters.terrain && filters.terrain !== 'menores terrenos' && filters.terrain !== 'maiores terrenos') {
      filtered = filtered.filter(project =>
        project.terrain.includes(filters.terrain)
      );
    }

    setFilteredProjects(filtered);
  };

  return (
    <div className="App min-h-screen bg-white">
      <Header />
      <HeroSection />
      <FilterSection onFilterChange={handleFilterChange} />
      
      {/* Projects Grid */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {loading ? (
          <div className="text-center py-16">
            <p className="text-gray-500 text-lg">Carregando projetos...</p>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredProjects.map((project) => (
                <ProjectCard key={project.id} project={project} />
              ))}
            </div>
            
            {filteredProjects.length === 0 && (
              <div className="text-center py-16">
                <p className="text-gray-500 text-lg">Nenhum projeto encontrado com os filtros selecionados.</p>
              </div>
            )}
          </>
        )}
      </section>

    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="flex flex-col min-h-screen">
          <div className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/projeto/:id" element={<ProjectDetails />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/checkout/cancel" element={<CheckoutCancel />} />
              <Route path="/checkout/pending" element={<CheckoutPending />} />
              <Route path="/carrinho" element={<CartPage />} />
              <Route path="/entrar" element={<CustomerAuth />} />
              <Route path="/redefinir-senha/:token" element={<ResetPassword />} />
              <Route path="/minha-conta" element={<MyAccount />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/settings" element={<AdminSettings />} />
              <Route path="/admin/files" element={<AdminFiles />} />
              <Route path="/admin/financeiro" element={<AdminFinanceiro />} />
              <Route path="/admin/email/config" element={<AdminEmailConfig />} />
              <Route path="/admin/email/templates" element={<AdminEmailTemplates />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;